module.exports = "<reusable-card icon=\"account_balance\" loading=\"$ctrl.loading\">\n  <card-content>\n    <reusable-table\n      title=\"Transaction Activity Details\" \n      columns=\"$ctrl.transactionColumns\"\n      data=\"$ctrl.transactions\"\n      on-add=\"$ctrl.addNewTransactionActivity()\"\n      on-edit=\"$ctrl.editTransactionActivity(item)\"\n      on-delete=\"$ctrl.deleteSelectedTransactionActivities(itemIds)\"\n      readonly=\"$ctrl.isViewOnly\"\n    </reusable-table>\n  </card-content>\n</reusable-card>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/clients.details/banking-activities/clientdetails.banking-activities.html
// module id = 1148
// module chunks = 0